import { HttpService } from '@/services/httpSerivce'
import { apiBaseUrl } from '@/utils/constants'

export class BimoboxApiService extends HttpService {
  constructor() {
    super(apiBaseUrl ?? '')
  }
}
